import { createGlobalStyle } from 'styled-components/macro';

import { Theme } from 'common/types/theme.type';

export const StyledScrolls = createGlobalStyle<{
  theme: Theme;
}>`
  body {
    * {
      scrollbar-width: thin;
      scrollbar-color: ${({ theme }) => theme.colors.scrollBg} transparent;
    }
  }
`;
